import { render, staticRenderFns } from "./Hint.vue?vue&type=template&id=bcbf6262"
import script from "./Hint.vue?vue&type=script&lang=ts"
export * from "./Hint.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_cache-loader@4.1.0_webpack@5.99.9__css-loader@6.1_ko473ranhrs7k4xxmt54qgngle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports